@if (!!folderId) {
  <app-table
    [items]="store.folderMedications()"
    [columns]="columns()"
    translatePrefix="person.dashboard."
    [hideCheckboxes]="true"
    [showDetail]="false"
    [showDelete]="false"
    >
    <ng-template pTemplate="icon" let-item="item">
      <app-link-button
        icon="pi-box"
        [pTooltip]="'folderMedication.updateTooltip' | translate"
        (clickEvent)="showUpdateMedicationDialog(item)"
      ></app-link-button>
    </ng-template>
    <ng-template pTemplate="iconHeader">
    </ng-template>
    <ng-template pTemplate="medicine" let-item="item">
      <div class="title title--primary">
        @if (item.customMedication) {
          <span>{{ item.customMedicationName }}</span>
        }
        <app-medication-info [medicationCode]="item.medicationCode"></app-medication-info>
      </div>
    </ng-template>
    <ng-template pTemplate="dosing" let-item="item">
      {{ item.dosingPeriod | formatDosing:item.dosing:store.globalGlobalStore.currentService()?.timeRanges}}
    </ng-template>
    <!-- TODO: odkaz na přehled doplnění (dotazy kdyztak na Vojtu) -->
    <ng-template pTemplate="stock" let-item="item">
      <app-button [text]="true" [label]="(item | countDaysDiff) | formatDaysDiff"
      [severity]="((item | countDaysDiff) <= 0 ? 'danger' : ((item | countDaysDiff) < 7 ? 'warning' : null))"></app-button>
    </ng-template>
  </app-table>
}
